export default "__VITE_ASSET__yoiz0ScS__"